<template>
    <div>
        <h4 class="Table-font mt-2 mb-3 f-700 text-dark"><i class="fa fa-table mr-2" aria-hidden="true"></i>History of leave information</h4>
        <div v-if="this.$store.state.permit.RulesUser.roles.includes('staff') || this.$store.state.permit.RulesUser.roles.includes('faculty')">
            <h5 class="font-en text-capitalize text-dark mt-2 mb-2">
                Absence Record
            </h5>
            <!-- leave - 1. -->
            <sum-leave @YearChange="getEmitYear"></sum-leave>
            <!-- leave - 2. -->
            <calendar-history 
                :blankAll="blankAll"
                :eventLeave="eventLeave"
                :viewListLeaveYear="viewListLeaveYear"
            ></calendar-history>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Baloo+Tamma+2&family=Varela+Round&display=swap');
    @import url('https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.0.0/animate.min.css');
    .form-control {
        background-color: #ffffff;
        border: 1px solid #ced4da;
        border-radius: 4px;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .font-500{ font-weight: 500; }
    .font-700{ font-weight: 700; }
    .card-custom {
        /* Add shadows to create the "card" effect */
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
        transition: 0.3s;
        border-radius: 10px;
    }
    .font-thai{ font-family: 'Kanit', sans-serif; font-weight: 100; }
    .font-en{ font-family: 'Rubik', sans-serif; font-weight: 300; }
</style>

<style>
    .select2-container .select2-selection--single .select2-selection__rendered {
        display: block;
        padding-left: 20px;
        padding-right: 42px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .select2-container--default .select2-selection--single .select2-selection__arrow {
        height: 26px;
        position: absolute;
        top: 7px;
        right: 1px;
        width: 20px;
    }
</style>

<script>
    import store from "@/store/index";
    import Select2 from 'v-select2-component';
    import SumLeave from "./sumLeave.vue";
    import CalendarHistory from './calenhistory.vue';
    export default {
        components: { Select2 , SumLeave , CalendarHistory },
        data() {
            return {
                YearData : this.moment().format('YYYY'),
                loadingViweAbsent: false,
                optionsSelectYear:[],
                itemLas:'',
                viewListLeaveYear: '',
                monthsList : ['October','November','December','January','February','March','April','May','June','July','August','September'],
                eventLeave:[],
                blankAll: []
            }
        },
        mounted(){
            this.setOptionYear()
            // this.getAbsentData()
        },
        methods: {
            // emit function
            getEmitYear(value){
                let mountOld = ['October','November','December']
                this.viewListLeaveYear = value.toString()
                let year_1 = parseInt(value) - 1
                let year_2 = value
                // 
                let startMonth = `October ${year_1.toString()}`
                let endMonth = `September ${year_2.toString()}`
                this.callYearFiscal(startMonth,endMonth,year_1.toString(),year_2.toString())
            },
            async callYearFiscal(startMonth,endMonth,y1,y2){
                this.eventLeave = []
                let startDateMont = `${y1}-10-01`
                let endDateMont = `${y2}-09-30`
                try {
                    const res = await this.$http.get(`/hri/leave_of_absence/?timestart=${startDateMont}&timeend=${endDateMont}`)
                    if(res.status === 200){
                        this.eventLeave.push({
                            'index': '',
                            'Month': '',
                            'dataLeave': res.data,
                        })
                        this.eventLeave.sort((a, b) =>{ return a.index - b.index; });
                        this.isNodata()
                    }
                } catch (error) {}
            },
            async callListLeaveInMount(MonthFormat,index){
                this.eventLeave = []
                var d = this.moment(MonthFormat);
                var startMonth = d.clone().startOf('month')
                var endMonth = d.clone().endOf('month')
                // 
                let startDateMont = this.moment(startMonth).format('YYYY-MM-DD')
                let endDateMont = this.moment(endMonth).format('YYYY-MM-DD')
                try {
                    const res = await this.$http.get(`/hri/leave_of_absence/?timestart=${startDateMont}&timeend=${endDateMont}`)
                    if(res.status === 200){
                        // console.log(res.data)
                        this.eventLeave.push({
                            'index': index,
                            'Month': MonthFormat,
                            'dataLeave': res.data,
                        })
                        this.eventLeave.sort((a, b) =>{ return a.index - b.index; });
                        this.isNodata()
                    }
                } catch (error) {}
            },
            isNodata(){
                this.blankAll = []
                for (let i = 0; i < this.eventLeave.length; i++) {
                    if(this.eventLeave[i].dataLeave.length == 0){
                        this.blankAll.push({
                            'Data':'empty'
                        })
                    }
                }
            },
            setOptionYear(){
                let year = this.moment().format('YYYY')
                for (let i = year; i > year - 9; i--) {
                    let thYear = parseInt(i) + parseInt(543)
                    this.optionsSelectYear.push({
                        'id': i,
                        'text': `${i} / ${thYear}`,
                    })
                }
            },
            async getAbsentData(){},
        }
    }
</script>